import _extends from '@babel/runtime/helpers/extends';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import classnames from 'classnames';
import React__default from 'react';

var _excluded = ["as", "className", "children", "data-testid", "target", "type"];
var Anchor = function Anchor(_ref) {
  var _ref$as = _ref.as,
    As = _ref$as === void 0 ? 'a' : _ref$as,
    className = _ref.className,
    children = _ref.children,
    dataTestId = _ref['data-testid'],
    target = _ref.target,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'default' : _ref$type,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var finalClasses = classnames('C-Anchor', _defineProperty({}, "--type-".concat(type), type), className);
  return /*#__PURE__*/React__default.createElement(As, _extends({
    className: finalClasses,
    "data-testid": dataTestId,
    target: target
  }, otherProps), children, target === '_blank' ? /*#__PURE__*/React__default.createElement("span", {
    className: "hc-sr-only",
    "data-testid": dataTestId ? "".concat(dataTestId, "_blank") : null
  }, "opens in a new window") : null);
};
Anchor.displayName = 'Anchor';

export { Anchor as default };
